import { Link, NavLink } from "react-router-dom";
import { useDealerPortalIntl } from "../../../hooks/useDealerPortalIntl";

export function DealerReportsNav({ active = "hub" }) {
  const { formatReportNavLabel } = useDealerPortalIntl();
  const items = [
    { key: "hub", href: "/v/automap/dealer/reportes" },
    { key: "rendimiento", href: "/v/automap/dealer/reportes/rendimiento" },
    { key: "leads", href: "/v/automap/dealer/reportes/leads" },
    { key: "inventario", href: "/v/automap/dealer/reportes/inventario" },
    { key: "fuentes", href: "/v/automap/dealer/reportes/fuentes" },
  ];
  return (
    <nav className="dealer-portal-nav dealer-reports-nav">
      {items.map((item) => (
        <NavLink
          key={item.key}
          to={item.href}
          end={item.key === "hub"}
          className={({ isActive }) => (isActive || active === item.key ? "active" : undefined)}
        >
          {formatReportNavLabel(item.key)}
        </NavLink>
      ))}
    </nav>
  );
}

export function ReportRangeSelect({ range, onChange }) {
  const { t, reportDateRangeOptions } = useDealerPortalIntl();
  return (
    <label className="dashboard-range-select">
      {t("common.period")}
      <select value={range} onChange={(e) => onChange(e.target.value)}>
        {reportDateRangeOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}

export function ReportSummaryGrid({ items }) {
  return (
    <div className="dashboard-summary-grid">
      {items.map((item) => (
        <div key={item.label} className="dashboard-summary-card">
          <span className="dashboard-summary-label">{item.label}</span>
          <strong className="dashboard-summary-value">{item.value ?? "—"}</strong>
          {item.hint ? <small className="muted">{item.hint}</small> : null}
        </div>
      ))}
    </div>
  );
}

export function SimpleTrendBars({ title, points = [] }) {
  const { t } = useDealerPortalIntl();
  if (!points.length) {
    return (
      <section className="dealer-state-box">
        <h3>{title}</h3>
        <p className="muted">{t("common.noDataInPeriod")}</p>
      </section>
    );
  }
  const max = Math.max(...points.map((p) => p.count), 1);
  return (
    <section className="dealer-state-box">
      <h3>{title}</h3>
      <div className="dashboard-trend-bars">
        {points.map((point) => (
          <div key={point.date} className="dashboard-funnel-row">
            <span>{point.date.slice(5)}</span>
            <div className="dashboard-funnel-bar">
              <div className="dashboard-funnel-fill" style={{ width: `${Math.round((point.count / max) * 100)}%` }} />
            </div>
            <strong>{point.count}</strong>
          </div>
        ))}
      </div>
    </section>
  );
}

export function RecommendedActions({ actions = [] }) {
  const { t } = useDealerPortalIntl();
  if (!actions.length) return null;
  return (
    <section className="dealer-state-box">
      <h3>{t("reports.recommendedActions")}</h3>
      <ul className="dashboard-checklist">
        {actions.map((action) => (
          <li key={action.id}>{action.message}</li>
        ))}
      </ul>
    </section>
  );
}

export function ReportExportButton({ dealerId, range, onExport }) {
  const { t } = useDealerPortalIntl();
  return (
    <button type="button" className="dealer-portal-btn" onClick={() => onExport(dealerId, range)}>
      {t("common.exportCsv")}
    </button>
  );
}

export function ReportPageHeader({ title, description, dealerId, range, onRangeChange, onExport, children }) {
  const { t } = useDealerPortalIntl();
  return (
    <div className="import-page-header">
      <div>
        <h2>{title}</h2>
        {description ? <p className="muted">{description}</p> : null}
      </div>
      <div className="import-actions">
        <ReportRangeSelect range={range} onChange={onRangeChange} />
        {onExport ? <ReportExportButton dealerId={dealerId} range={range} onExport={onExport} /> : null}
        {children}
        <Link className="dealer-portal-btn" to="/v/automap/dealer/dashboard">
          {t("common.backToDashboard")}
        </Link>
      </div>
    </div>
  );
}
